<form [formGroup]="projectGroupForm">

    <ng-container *ngIf="loading">
        <acabim-loading-view></acabim-loading-view>
    </ng-container>

    <ng-container *ngIf="!loading">
        <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true" [shortFields]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Project group name</acabim-form-input-label>
                <acabim-form-input-content>
                    <input type="text" formControlName="projectGroupName" id="project-group-name" placeholder="Enter a project group name">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
        <p-footer class="cas-form-footer">
            <div class="cas-action-buttons">
                <button class="cas-button-action" (click)="onProjectGroupAddSubmit()">Add</button>
                <button (click)="onCancel()">Cancel</button>
            </div>
        </p-footer>
    </ng-container>

</form>
